import React, { useEffect, useState } from 'react'
import Inputwithlable from '../../components/common/inputwithlable'
import { LOGO_IMG } from '../../../utills/image-constant'
import { checkValidation, ErrorMessage, ErrorMsg } from '../../../utills/error-message-constant'
import Loginbtn from '../../components/common/loginbtn'
import { toastEmitter } from '../../../utills/utilities'
import { handleFormInput } from '../../../utills/formutilities'
import { passwordRegex } from '../../../utills/form-regex'
import { adminResetPassword } from '../../../services/api-services'
import { useNavigate } from 'react-router-dom'
import { API_RESPONSE } from '../../../utills/app-constant'

const RessetPassword = () => {
    const [formError, setFormError] = useState();
    const [resetbtnLoader, setResetbtnLoader] = useState(false)
    const [resetbtndisable, setResetbtndisable] = useState(true)
    const [resetPasswordPayload, setResetPasswordPayload] = useState({
        email: "",
        password: "",
        confirmPassword: ""
    })
    let Navigation = useNavigate()
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const emailData = queryParams.get('email');
        if (emailData) {
            setResetPasswordPayload((prevState) => ({
                ...prevState,
                email: emailData
            }));
        }
    }, []);


    useEffect(() => {
        const isPasswordValid = resetPasswordPayload?.password && resetPasswordPayload?.confirmPassword && !formError?.password && !formError?.confirmPassword;
        setResetbtndisable(!isPasswordValid);
    }, [formError, resetPasswordPayload]);


    const handleResetPassword = (e) => {
        const { name, value } = e.target;
        if (name === "password") {
            checkValidation(
                value,
                name,
                ErrorMessage?.Valid?.Password,
                passwordRegex,
                formError,
                setFormError
            );
        }
        if (name === "confirmPassword") {
            checkValidation(
                value,
                name,
                ErrorMessage?.Valid?.ConfirmPassword,
                passwordRegex,
                formError,
                setFormError
            );
        }
        setResetPasswordPayload(handleFormInput(e, resetPasswordPayload));
    }

    const handleSubmitPassword = async () => {
        setResetbtnLoader(true)
        setResetbtndisable(true)
        if (resetPasswordPayload?.password !== resetPasswordPayload?.confirmPassword) {
            toastEmitter("error", "Password and Confirm password should be Same !");
            setResetbtnLoader(false)
            setResetbtndisable(true)
            return
        }

        let payload = {
            email: resetPasswordPayload?.email,
            password: resetPasswordPayload?.password
        }
        try {
            const response = await adminResetPassword(payload);
            if (response?.data?.responseCode !== 200) {
                toastEmitter("error", response?.data?.message);
                setResetbtnLoader(false)
                setResetbtndisable(true)
            }

            if (response.data?.responseCode === 200) {
                toastEmitter("success", response?.data?.message);
                Navigation(process.env.PUBLIC_URL + "/")
                setResetbtnLoader(false)
                setResetbtndisable(true)
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
            setResetbtnLoader(false)
            setResetbtndisable(true)
        }
    }

    return (
        <>
            <>
                <div className="caspera_login_account_content d-flex justify-content-center align-items-center">
                    <div class="card forget-div rounded-4 shadow-sm p-5 pt-4 pb-4 border-0">
                        <div class="card-body">
                            <div className='d-flex justify-content-center align-items-center'>
                                <img src={LOGO_IMG} class="img-fluid mb-4 logo_img" alt="..." />
                            </div>
                            <p class="card-text text-center fw-bold fs-4">Reset Password</p>
                            <div class="">
                                <Inputwithlable
                                    type="text"
                                    name="password"
                                    labelName="New Password"
                                    lableclassName='input-label'
                                    className="form-control inputText-lable"
                                    placeholder="Enter Password"
                                    handleChange={handleResetPassword}
                                    value={resetPasswordPayload?.password}
                                    error={formError?.passwordStatus}
                                />
                            </div>
                            <div className="mt-2 ms-2"><ErrorMsg error={formError?.password} /></div>
                            <div class="">
                                <Inputwithlable
                                    type="text"
                                    name="confirmPassword"
                                    labelName="Confirm Password"
                                    lableclassName='input-label'
                                    className="form-control inputText-lable"
                                    placeholder="Confirm Password"
                                    handleChange={handleResetPassword}
                                    value={resetPasswordPayload?.confirmPassword}
                                    error={formError?.confirmPasswordStatus}
                                />
                            </div>
                            <div className="mt-2 ms-2"><ErrorMsg error={formError?.confirmPassword} /></div>

                            <Loginbtn
                                className="submitbtn textfont12 mt-3"
                                handleClick={handleSubmitPassword}
                                type="submit"
                                btnName="SUBMIT"
                                disablebtn={resetbtndisable}
                                loader={resetbtnLoader}
                            />
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default RessetPassword
